
import { Component, Vue } from 'vue-property-decorator'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import UpdateDialog from './updateAreaDialog.vue'
import ConfigLogDialog from '../configLog.vue'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'tutorConfig',
  components: {
    UpdateDialog,
    ConfigLogDialog
  }
})
export default class extends Vue {
  private tableData = []
  private columns = [
    { field: 'id', title: 'ID', width: 100 },
    { field: 'name', title: '地区名称', width: 400 },
    { field: 'buildings', title: '下属基地' }
  ]

  private updateType = 'add' // 新建/编辑类型 add-新建，edit-编辑
  private currentNode = {} // 当前选择的节点
  private total = 0 // 总条数
  private currentPage = 1
  private pageSize = 10

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  mounted() {
    this.getTableData()
  }

  // 获取表格数据
  private async getTableData() {
    await CONFIGAPI.getAreaData({
      page: this.currentPage,
      page_size: this.pageSize,
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.total = res.data.count
        this.tableData = res.data.lists
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 查看操作日志
  handleShowLog() {
    ConfigModule.ToggleDialogStatus({
      name: 'configLogDialog',
      value: true
    })
  }

  // 新增
  private handleCreate() {
    this.updateType = 'add'
    ConfigModule.ToggleDialogStatus({
      name: 'areaAddDialog',
      value: true
    })
  }

  // 编辑
  private handleEdit(data: any) {
    this.updateType = 'edit'
    this.currentNode = data
    ConfigModule.ToggleDialogStatus({
      name: 'areaAddDialog',
      value: true
    })
  }

  // 删除
  private handleDelete(data: any) {
    if (data.buildings.length > 0) {
      this.$alert(`【${data.name}】地区下的基地列表不为空，不能直接删除该地区！`, {
        confirmButtonText: '知道了'
      })
    } else {
      this.$confirm(`确定要删除当前地区么？【${data.name}】`)
        .then(_ => {
          CONFIGAPI.delArea({
            id: data.id
          }, {
            app_id: this.userCurrentApp
          }).then((res) => {
            if (res.stat === 1) {
              this.$message.success(res.data)
              this.getTableData()
            }
          }).catch((error) => {
            console.log('发生错误！', error)
          })
        })
        .catch(_ => {})
    }
  }

  // 跳转基地
  handleDetail(data: any) {
    this.$router.push({ name: 'areaConfig', params: { id: data.id } })
  }

  handleStrategyDetail(data: any) {
    this.$router.push({ name: 'strategyConfig', params: { id: data.id } })
  }

  // 子组件接口调用成功后
  private handleSuccess() {
    this.getTableData()
  }

  private handleSizeChange(val: number) {
    this.currentPage = 1
    this.pageSize = val
    this.getTableData()
  }

  private handleCurrentChange(val: number) {
    this.currentPage = val
    this.getTableData()
  }
}
